<template>
	<div>
		<el-dropdown size="small" class="d2-mr">
			<span class="btn-text">{{info.name ? `你好 ${info.name}` : '未登录'}}</span>
			
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item @click.native="editPassword">
					<d2-icon name="lock" class="d2-mr-5" />
					修改密码
				</el-dropdown-item>
				
				<el-dropdown-item @click.native="logOff">
					<d2-icon name="power-off" class="d2-mr-5" />
					注销
				</el-dropdown-item>
				
			</el-dropdown-menu>
		</el-dropdown>
		
		<el-dialog title="修改登录密码" :visible.sync="isShowEditPassword" :close-on-click-modal="false" :before-close="closeEditPassword" width="800px">
			<el-form ref="form" :model="editForm" :rules="editFormRules" label-width="110px">
				<el-row>
					<el-col :span="24">
						<el-form-item label="旧密码" prop="oldPwd">
							<el-input type="password" v-model="editForm.oldPwd" placeholder="请输入旧登录密码" clearable></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				
				<el-row>
					<el-col :span="24">
						<el-form-item label="新密码" prop="newPwd">
							<el-input type="password" v-model="editForm.newPwd" placeholder="请输入新登录密码" clearable></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				
				<el-row>
					<el-col :span="24">
						<el-form-item label="确认新密码" prop="newPwdConfirm">
							<el-input type="password" v-model="editForm.newPwdConfirm" placeholder="请再次输入新登录密码" clearable></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			
			<div slot="footer">
				<el-button type="primary" @click="submitEditPassword">提交修改</el-button>
				<el-button @click="closeEditPassword">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex'
	import { EditUserPassword } from '@api/user/user'
	import md5 from 'js-md5'
	export default {
		data() {
			let validatePwdConfirm = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入新密码'));
				} else if (value != this.editForm.newPwd) {
				 	callback(new Error('两次输入的密码不一致，请重新输入'));
				} else {
					callback();
				}
			}
			return {
				isShowEditPassword: false,
				editForm: {
					oldPwd: '',
					newPwd: '',
					newPwdConfirm: '',
				},
				editFormRules: {
					oldPwd: [{ required: true, message: '请填写旧密码', trigger: 'blur' }],
					newPwd: [{ required: true, message: '请填写新密码', trigger: 'blur' }],
					newPwdConfirm: [{ required: true, validator: validatePwdConfirm, trigger: 'blur' }],
				}
			}
		},
		computed: {
			...mapState('d2admin/user', ['info'])
		},
		methods: {
			...mapActions('d2admin/account', ['logout']),
			/**
			 * @description 登出
			 */
			logOff() {
				this.logout({
					confirm: true
				})
			},
			
			/**
			 * @description 修改登录密码
			 */
			editPassword() {
				this.isShowEditPassword = true;
			},
			submitEditPassword() {
				this.$refs.form.validate((valid) => {
					if (valid) {
						let params = {
							oldPwd: md5(this.editForm.oldPwd),
							newPwd: md5(this.editForm.newPwd),
							newPwdConfirm: md5(this.editForm.newPwdConfirm),
						}
						EditUserPassword(params)
							.then(() => {
								this.$message.success('密码修改成功，请重新登录！');
								
								setTimeout(() => {
									this.logout();
								}, 1500);
							})
					}
				})
			},
			closeEditPassword() {
				this.isShowEditPassword = false;
				this.$refs.form.resetFields();
			}
		}
	}
</script>
<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/header-user/index.vue"
}
</vue-filename-injector>
